import React from "react";
//#region redux
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store";
import { updateLastViewedTab } from "store/actions/todoActions";
//#endregion
//#region types
import { WidgetBaseProps } from "models/propTypes/commonPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import TodosWidgetHeader from "./_partials/widget/header";
import TodosByUrgency from "./_partials/widget/byUrgency";
import TodosByType from "./_partials/widget/byType";
import { Grid } from "@mui/material";
//#endregion

const TodosWidget: React.FC<WidgetBaseProps> = (props) => {
  const dispatch = useDispatch();

  const todoCount = useSelector((store: AppState) => store.todos.todoSummary?.totalTodosCount);
  const grouping = useSelector((store: AppState) => store.todos.lastViewedTab);

  const onGroupTypeChanged = (group: WintSuperkollAPIModel.TodoGroupType) => {
    dispatch(updateLastViewedTab(group));
  };

  const getIsVisible = () => todoCount !== undefined && todoCount > 0;

  React.useEffect(() => {
    props.onVisibilityChange && props.onVisibilityChange(!getIsVisible());
  }, [todoCount]);

  return getIsVisible() ? (
    <Grid container rowGap={3}>
      <TodosWidgetHeader
        groupTypeChangeHandler={onGroupTypeChanged}
        todoCount={todoCount}
        initialSelection={grouping}
      />
      {grouping === WintSuperkollAPIModel.TodoGroupType.Urgency ? <TodosByUrgency /> : <TodosByType />}
    </Grid>
  ) : (
    <></>
  );
};

export default TodosWidget;
